"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ELKFormatter = void 0;
var ELKFormatter = /** @class */ (function () {
    // eslint-disable-next-line @typescript-eslint/no-parameter-properties
    function ELKFormatter(appInfo) {
        this.appInfo = appInfo;
    }
    ELKFormatter.prototype.format = function (log) {
        var elkAppInfo = {
            runtime: 'browser',
            application: this.appInfo.application,
            mcs_run_env: this.appInfo.mcsRunEnv,
            version: this.appInfo.version,
            href: this.appInfo.href,
            available_screen_size: this.appInfo.availableScreenSize,
            screen_size: this.appInfo.screenSize,
        };
        return JSON.stringify(Object.assign(elkAppInfo, log));
    };
    return ELKFormatter;
}());
exports.ELKFormatter = ELKFormatter;
//# sourceMappingURL=ELKFormatter.js.map